import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import React, { Suspense } from 'react';
import { AdminContextProvider, AdminEditedPageLeaveContextProvider, } from "./contexts/context";
import { NavSidebar } from './components/nav-sidebar';
import { Sidebar } from './components/sidebar';
import { ViewPrivilegeModal } from './components/user-management/roles/view-privilege/view-privilege-modal.container';
const App = React.lazy(() => import('./components/app/app').then(m => ({ default: m.App })));
function withProviders(Component, options) {
    return (React.createElement(AdminEditedPageLeaveContextProvider, null,
        React.createElement(AdminContextProvider, { ...options }, Component)));
}
export const AdminPage = ({ rootPath, ...rest }) => {
    return withProviders(React.createElement(Suspense, { fallback: React.createElement(LoadingIndicator, null,
            React.createElement(React.Fragment, null)) },
        React.createElement(App, null)), {
        rootPath,
        ...rest,
    });
};
export { ViewPrivilegeModal, Sidebar, NavSidebar };
export { getCustomisationItemTabs, getSideBarConfig, getSidebarSectionsFromResponse, getUserManagementItemTabs, USER_MANAGEMENT_TAB_IDS, } from './utils/sidebar-config';
export { tabIdToSlug, parseAdminItemPath, } from './utils/admin-route-utils';
export { buildCommandRegistry, } from './utils/admin-command-registry';
export { useGetStatusLazy, useGetSidebarConfigLazy, useGetSidebarConfigLazyNoCache, } from './services/sidebar/sidebar-service';
//# sourceMappingURL=admin.js.map